const device = {
    state: {
        GroupingName: '',
        KeepAlive: true
    },
    mutations: {
        //获取分组跳转过来的名字
        GET_GROUPINGNAME(state, name) {
            state.GroupingName = name
        },
        //控制设备列表缓存
        SHOW_KEEPALIVE(state, show) {
            state.KeepAlive = show
        },
        REMOVE_GROUPINGNAME(state){
            state.GroupingName = ''
        }
    },
    actions: {
        //触发保存分组跳转的分组名
        GetGroupingName({ commit }, name) {
            commit('GET_GROUPINGNAME', name)
        },
        //触发设备列表缓存(废弃)
        ShowKeepAlive({ commit }, show) {
            commit('SHOW_KEEPALIVE', show)
        },
        // 移除保存的分组名
        RemoveGroupingName({ commit }) {
            commit('REMOVE_GROUPINGNAME')
        },
    }
}

export default device